// extracted by mini-css-extract-plugin
export default {"container":"qr-z","ratingLayout":"rr-z","ratingLabel":"sr-z","nonInteractiveRatingLabel":"tr-z"};